/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Valve_Add_InfoInputs */



/**
* | output |
* | --- |
* | "Click on the map to add the thermostatic head" |
*
* @param {Valve_Add_InfoInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_add_info = /** @type {((inputs?: Valve_Add_InfoInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Add_InfoInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Click on the map to add the thermostatic head")
	return /** @type {LocalizedString} */ ("Cliquez sur le plan pour ajouter la tête thermostatique")
});